// extracted by mini-css-extract-plugin
module.exports = {"content":"YearReview_content__1Bkeh","hero":"YearReview_hero__1m9mx","bottom":"YearReview_bottom__bK2ex"};